import React from 'react';
import { Phone, Mail, ExternalLink, Linkedin, MapPin } from 'lucide-react';
import { LOGOS, CONTACT } from '../lib/constants';
const serviceLinks = [{
  label: 'Managed Services',
  accent: '#0AA77E'
}, {
  label: 'Security',
  accent: '#D2223D'
}, {
  label: 'Hosting',
  accent: '#57578E'
}, {
  label: 'Voice',
  accent: '#F2612A'
}, {
  label: 'Services overview'
}];
const columns: {
  title: string;
  links: string[];
}[] = [{
  title: 'Industries',
  links: ['Legal', 'Accounting', 'Engineering', 'Health']
}, {
  title: 'Why CT Group',
  links: ['Our Difference', 'Our Own Infrastructure', 'Client Outcomes', 'Independent IT Review', 'Our Story']
}, {
  title: 'Resources',
  links: ['Essential Eight Data Pack', 'Switching Providers Guide', 'IT Review Explainer', 'Insights', 'FAQ']
}];
const cities = ['Perth', 'Melbourne', 'Sydney', 'Brisbane'];
export function Footer() {
  return <footer className="w-full bg-navy pt-16 text-white/80" data-id="element-23">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr]" data-id="element-25">
          {/* brand */}
          <div data-id="element-26">
            <span className="inline-flex items-center rounded-xl bg-white px-4 py-3 shadow-sm" data-id="element-27">
              <img src={LOGOS.main} alt="CT Group" className="h-9" data-id="element-28" />
            </span>
            <p className="mt-5 max-w-xs text-[15px] leading-relaxed text-white/70" data-id="element-29">
              End-to-end managed IT for professional services firms.
            </p>
            <p className="mt-2 text-[12px] font-semibold uppercase tracking-[0.14em] text-ct-light/70" data-id="element-30">
              Efficiency through IT
            </p>
            <div className="mt-6 space-y-2.5 text-[14px]" data-id="element-31">
              <a href={CONTACT.phoneHref} className="flex items-center gap-2 text-white/80 hover:text-white" data-id="element-32">
                <Phone className="h-4 w-4 text-ct-cyan" aria-hidden data-id="element-33" />{' '}
                {CONTACT.phone}
              </a>
              <a href={CONTACT.emailHref} className="flex items-center gap-2 text-white/80 hover:text-white" data-id="element-34">
                <Mail className="h-4 w-4 text-ct-cyan" aria-hidden data-id="element-35" />{' '}
                {CONTACT.email}
              </a>
              <a href="#portal" className="flex items-center gap-2 text-white/80 hover:text-white" data-id="element-36">
                <ExternalLink className="h-4 w-4 text-ct-cyan" aria-hidden data-id="element-37" />{' '}
                Client Portal
              </a>
              <a href="#linkedin" className="flex items-center gap-2 text-white/80 hover:text-white" data-id="element-38">
                <Linkedin className="h-4 w-4 text-ct-cyan" aria-hidden data-id="element-39" />{' '}
                LinkedIn
              </a>
            </div>
          </div>

          {/* services */}
          <div data-id="element-40">
            <h3 className="font-display text-[14px] font-bold uppercase tracking-wide text-white" data-id="element-41">
              Services
            </h3>
            <ul className="mt-4 space-y-2.5 text-[14px]" data-id="element-42">
              {serviceLinks.map(s => <li key={s.label} data-id="element-43">
                  <a href="#" className="flex items-center gap-2 text-white/70 hover:text-white" data-id="element-44">
                    {s.accent && <span className="h-2 w-2 rounded-full" style={{
                  background: s.accent
                }} aria-hidden data-id="element-45" />}
                    <span className={s.accent ? '' : 'ml-4'} data-id="element-46">{s.label}</span>
                  </a>
                </li>)}
            </ul>
          </div>

          {columns.slice(0, 2).map(col => <div key={col.title} data-id="element-47">
              <h3 className="font-display text-[14px] font-bold uppercase tracking-wide text-white" data-id="element-48">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-2.5 text-[14px]" data-id="element-49">
                {col.links.map(l => <li key={l} data-id="element-50">
                    <a href="#" className="text-white/70 hover:text-white" data-id="element-51">
                      {l}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-10 border-t border-white/10 pt-8 lg:grid-cols-[1.4fr_1fr_2fr]" data-id="element-52">
          <div data-id="element-53">
            <h3 className="font-display text-[14px] font-bold uppercase tracking-wide text-white" data-id="element-54">
              Resources
            </h3>
            <ul className="mt-4 space-y-2.5 text-[14px]" data-id="element-55">
              {columns[2].links.map(l => <li key={l} data-id="element-56">
                  <a href="#" className="text-white/70 hover:text-white" data-id="element-57">
                    {l}
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-58">
            <h3 className="font-display text-[14px] font-bold uppercase tracking-wide text-white" data-id="element-59">
              Locations
            </h3>
            <ul className="mt-4 space-y-2.5 text-[14px]" data-id="element-60">
              {cities.map(c => <li key={c} className="flex items-center gap-2 text-white/70" data-id="element-61">
                  <MapPin className="h-3.5 w-3.5 text-ct-cyan" aria-hidden data-id="element-62" />
                  {c}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-white/10 py-6 text-[13px] text-white/50 sm:flex-row sm:items-center" data-id="element-63">
          <p data-id="element-64">© {new Date().getFullYear()} CT Group. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-65">
            <a href="#" className="hover:text-white" data-id="element-66">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-67">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>;
}